import {
  VStack,
  Heading,
  Text,
  SimpleGrid,
  GridItem,
  FormControl,
  FormLabel,
  Button,
  useColorModeValue,
  Input,
  RadioGroup,
  Radio,
  HStack,
  AlertDialogContent,
  AlertDialog,
  AlertDialogBody,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogCloseButton,
  AlertDialogOverlay,
} from "@chakra-ui/react";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactGa from "react-ga";

type SubmitFeedbackBody = {
  creationTime: number;
  isHelpful: boolean;
  feedback: string;
  name?: string;
  email?: string;
};

const FeedbackForm = () => {
  const bgColor = useColorModeValue("gray.50", "whiteAlpha.50");

  const cancelRef = React.useRef<HTMLButtonElement>(null);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [isHelpful, setIsHelpful] = useState("");
  const [feedback, setFeedback] = useState("");
  const [showAppreciation, setShowAppreciation] = useState(false);
  const [isError, setIsError] = useState(false);
  const onClose = () => setShowAppreciation(false);
  let navigate = useNavigate();

  const onClickLinkedInButton = () => {
    setShowAppreciation(false);
    ReactGa.event({
      category: "Button",
      action: "LinkedIn",
    });
    window.open("https://www.linkedin.com/in/dalson-tan/", "_blank");
  };

  const onClickGithubButton = () => {
    setShowAppreciation(false);
    ReactGa.event({
      category: "Button",
      action: "Github",
    });
    window.open("https://github.com/dalsontws", "_blank");
  };

  const onClickCloseAppreciationButton = () => {
    setShowAppreciation(false);
    navigate("/");
  };

  const onClickCloseErrorButton = () => {
    setIsError(false);
  };

  const clearForm = () => {
    setName("");
    setEmail("");
    setIsHelpful("");
    setFeedback("");
  };

  const handleOnSubmit = async () => {
    let body: SubmitFeedbackBody;

    // TODO: some form of validation

    if (feedback.trim() === "") {
      setIsError(true);
      return;
    }

    body = {
      creationTime: Date.now(),
      isHelpful: isHelpful === "yes" ? true : false,
      feedback,
      name,
      email,
    };
    console.log(body);
    const endpoint = process.env.REACT_APP_ENDPOINT as string;

    const path = "/api/feedback/create";

    try {
      const response = await axios.post(`${endpoint}${path}`, body);
      console.log(response);
    } catch (e) {
      console.log(e);
    }

    clearForm();

    setShowAppreciation(true);
  };

  useEffect(() => {
    ReactGa.initialize("UA-213501626-1");

    ReactGa.pageview("/feedback");
  });

  return (
    <>
      <VStack
        w="full"
        h="full"
        p={10}
        spacing={6}
        alignItems="flex-start"
        bg={bgColor}
      >
        <VStack spacing={3} alignItems="flex-start">
          <Heading size="2xl">Feedback</Heading>
          <Text flexDirection="row">Let us know what you think!</Text>
        </VStack>
        <SimpleGrid columns={12} columnGap={3} rowGap={6} w="full">
          <GridItem colSpan={6}>
            <FormControl id="name">
              <FormLabel>Name</FormLabel>
              <Input
                fontSize="md"
                placeholder="If you wish to be identifiable!"
                size="md"
                onChange={(event) => setName(event.currentTarget.value)}
              ></Input>
            </FormControl>
          </GridItem>
          <GridItem colSpan={6}>
            <FormControl id="email">
              <FormLabel>Email</FormLabel>
              <Input
                fontSize="md"
                placeholder="If you wish to be contactable!"
                size="md"
                onChange={(event) => setEmail(event.currentTarget.value)}
              ></Input>
            </FormControl>
          </GridItem>
          <GridItem colSpan={12}>
            <FormControl as="fieldset">
              <FormLabel as="legend">
                Was this web app helpful to you?
              </FormLabel>
              <RadioGroup
                defaultValue="no"
                onChange={(event) => setIsHelpful(event)}
              >
                <HStack spacing="24px">
                  <Radio value="yes">Yes</Radio>
                  <Radio value="no">No</Radio>
                </HStack>
              </RadioGroup>
            </FormControl>
          </GridItem>
          <GridItem colSpan={12}>
            <FormControl id="feedback" isRequired>
              <FormLabel>What can we improve/include?</FormLabel>
              <Input
                placeholder="Add your feedback here"
                onChange={(event) => setFeedback(event.currentTarget.value)}
              />
            </FormControl>
          </GridItem>
          <GridItem>
            <Button
              mt={4}
              colorScheme="teal"
              onClick={handleOnSubmit}
              type="submit"
            >
              Submit
            </Button>
          </GridItem>
        </SimpleGrid>
      </VStack>
      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isOpen={showAppreciation}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Thanks for your feedback!</AlertDialogHeader>
          <AlertDialogCloseButton onClick={onClickCloseAppreciationButton} />
          <AlertDialogBody>
            If you wish to connect with me, do click on the buttons below!
            Otherwise, thanks for visiting!
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button onClick={onClickGithubButton}>GitHub</Button>
            <Button
              onClick={onClickLinkedInButton}
              colorScheme="linkedin"
              ml={3}
            >
              LinkedIn
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      <AlertDialog
        motionPreset="slideInBottom"
        leastDestructiveRef={cancelRef}
        onClose={onClose}
        isOpen={isError}
        isCentered
      >
        <AlertDialogOverlay />

        <AlertDialogContent>
          <AlertDialogHeader>Invalid feedback input</AlertDialogHeader>
          <AlertDialogCloseButton onClick={onClickCloseAppreciationButton} />
          <AlertDialogBody>
            Do ensure your feedback is entered before clicking submit!
          </AlertDialogBody>
          <AlertDialogFooter>
            <Button onClick={onClickCloseErrorButton} colorScheme="red" ml={3}>
              Back
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </>
  );
};

export default FeedbackForm;
